import type { User } from 'api/types/user';

export type ImpersonatedUserInfo = Pick<User, 'id' | 'email' | 'firstName' | 'lastName'>;

const IMPERSONATION_STORAGE_KEY = 'dmsark_impersonate';

interface StoredImpersonation {
  impersonatedUserId: string | null;
  impersonatedUser: ImpersonatedUserInfo | null;
}

export function getStoredImpersonation(): StoredImpersonation {
  try {
    const raw = sessionStorage.getItem(IMPERSONATION_STORAGE_KEY);
    if (!raw) return { impersonatedUserId: null, impersonatedUser: null };
    const parsed = JSON.parse(raw) as {
      impersonatedUserId?: string | null;
      impersonatedUser?: ImpersonatedUserInfo | null;
    };
    return {
      impersonatedUserId: parsed.impersonatedUserId ?? null,
      impersonatedUser: parsed.impersonatedUser ?? null
    };
  } catch {
    return { impersonatedUserId: null, impersonatedUser: null };
  }
}

export function getStoredImpersonatedUserId(): string | null {
  return getStoredImpersonation().impersonatedUserId;
}

export function syncImpersonationToStorage(
  impersonatedUserId: string | null,
  impersonatedUser: ImpersonatedUserInfo | null
): void {
  try {
    if (impersonatedUserId && impersonatedUser) {
      sessionStorage.setItem(
        IMPERSONATION_STORAGE_KEY,
        JSON.stringify({ impersonatedUserId, impersonatedUser })
      );
    } else {
      sessionStorage.removeItem(IMPERSONATION_STORAGE_KEY);
    }
  } catch {
    // ignore
  }
}

export function clearImpersonationStorage(): void {
  try {
    sessionStorage.removeItem(IMPERSONATION_STORAGE_KEY);
  } catch {
    // ignore
  }
}
